import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigQuestion } from '../../models/config-question.interface';
import {
	ControlValueAccessor,
	UntypedFormGroup,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ErrorMessage } from '../../constants/enum.const';

@Component({
	selector: 'bcb-generic-currency',
	templateUrl: './generic-currency.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: GenericCurrencyComponent,
		},
	],
	styleUrls: ['./generic-currency.component.scss'],
})
export class GenericCurrencyComponent implements ControlValueAccessor {
	@Input() question!: ConfigQuestion;
	@Input() formGroup!: UntypedFormGroup;
	@Input() formGroupName!: string;
	@Input() errorMessage: ErrorMessage | undefined;
	@Output() change: EventEmitter<any> = new EventEmitter<any>();

	value: any;
	isDisabled: boolean = false;

	constructor() {}

	changed: (value: any) => void = () => {};

	touched: () => void = () => {};

	writeValue(obj: any): void {
		this.value = obj;
	}

	onChange(): void {
		const val = this.formGroup?.get(this.formGroupName)?.value;
		this.changed(val);
		this.change.emit(val);
	}

	registerOnChange(fn: any): void {
		this.changed = fn;
	}

	registerOnTouched(fn: any): void {
		this.touched = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}
}
